const MOMENT_FORMATS = {
  MONTH_DAYS_COMMA_YEAR: 'MMM DD, YYYY',
  HOURS_MINUTES: 'HH:mm'
}

export { MOMENT_FORMATS }
export default MOMENT_FORMATS
